import { FC, useCallback, useEffect, useState } from "react";
import { useModal } from "../../../core";
import { CloseModalIcon } from "../../../core/modules/CloseIconNew";
import { API, Endpoints, Project } from "@brg/api";
import { BrgButton, ButtonVariant, useToasts } from "@brg/ui";
import { Trans, useTranslation } from "react-i18next";
import { RectangularButtonFilled } from "../../components/buttons";
import {
    TransferModalBodyLink,
    CloseModalIconWrapper,
    TransferModalHeaderRow,
    TransferModalTitleMain,
    TransferModalDescription,
    TransferLinkInputWrapperAtBottom,
    TransferLinkInput,
    InstructionsList,
    Divider,
    BottomGroup,
} from "./styles";

export interface TransferProjectLinkModalProps {
    projectId?: string;
    project?: Project;
}

export const TransferProjectLinkModal: FC<TransferProjectLinkModalProps> = ({ projectId }) => {
    const modal = useModal();
    const toasts = useToasts();
    const { t } = useTranslation();
    const [link, setLink] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loadError, setLoadError] = useState<string | null>(null);

    const fullLink = link ?? "";

    useEffect(() => {
        if (!projectId) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        setLoadError(null);
        API.request()
            .endpoint(Endpoints.geograffee)
            .url("/api/DataTransfer/ExportProject")
            .post()
            .addQuery("projectId", projectId)
            .send()
            .then((r: Response) => (r?.ok ? r.text() : Promise.reject()))
            .then((code: string) => {
                const trimmed = code?.trim() ?? "";
                const withoutQuotes = trimmed.replace(/^"|"$/g, "");
                setLink(withoutQuotes || null);
            })
            .catch(() => {
                const msg = t("transfer_project_modal.error_load");
                setLoadError(msg);
                toasts.error(msg);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [projectId, t]);

    const onCopy = useCallback(() => {
        if (!fullLink) return;
        navigator.clipboard.writeText(fullLink).then(
            () => {
                toasts.info(t("link_copied"));
            },
            () => {
                toasts.error(t("transfer_project_modal.error_copy"));
            }
        );
    }, [fullLink, toasts, t]);

    const onClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    const isReady = !!link;

    return (
        <TransferModalBodyLink>
            <TransferModalHeaderRow>
                <TransferModalTitleMain>
                    {isReady ? t("transfer_project_modal.step2_title_ready") : t("transfer_project_modal.step2_title_loading")}
                </TransferModalTitleMain>
                <CloseModalIconWrapper>
                    <CloseModalIcon onClick={onClose} width={22} height={22} />
                </CloseModalIconWrapper>
            </TransferModalHeaderRow>
            <InstructionsList>
                <TransferModalDescription as="li">
                    {t("transfer_project_modal.copy_code")}
                </TransferModalDescription>
                <TransferModalDescription as="li">
                    <Trans i18nKey="transfer_project_modal.receive_project" />
                </TransferModalDescription>
            </InstructionsList>
            <Divider />
            <BottomGroup>
                <TransferModalDescription>
                    {isReady
                        ? t("transfer_project_modal.step2_description_ready")
                        : t("transfer_project_modal.step2_description_loading")}
                </TransferModalDescription>
                <TransferLinkInputWrapperAtBottom>
                    <TransferLinkInput
                        type="text"
                        readOnly
                        value={fullLink}
                        placeholder={t("transfer_project_modal.placeholder")}
                    />
                    <BrgButton variant={ButtonVariant.Filled} disabled={!isReady} onClick={onCopy}>
                        {t("transfer_project_modal.copy")}
                    </BrgButton>
                </TransferLinkInputWrapperAtBottom>
            </BottomGroup>
        </TransferModalBodyLink>
    );
};
import { FC, useCallback, useEffect, useState } from "react";
import { useModal } from "../../../core";
import { CloseModalIcon } from "../../../core/modules/CloseIconNew";
import { API, Endpoints, Project } from "@brg/api";
import { BrgButton, ButtonVariant, useToasts } from "@brg/ui";
import { Trans, useTranslation } from "react-i18next";
import { RectangularButtonFilled } from "../../components/buttons";
import {
    TransferModalBodyLink,
    CloseModalIconWrapper,
    TransferModalHeaderRow,
    TransferModalTitleMain,
    TransferModalDescription,
    TransferLinkInputWrapperAtBottom,
    TransferLinkInput,
    InstructionsList,
    Divider,
    BottomGroup,
} from "./styles";

export interface TransferProjectLinkModalProps {
    projectId?: string;
    project?: Project;
}

export const TransferProjectLinkModal: FC<TransferProjectLinkModalProps> = ({ projectId }) => {
    const modal = useModal();
    const toasts = useToasts();
    const { t } = useTranslation();
    const [link, setLink] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loadError, setLoadError] = useState<string | null>(null);

    const fullLink = link ?? "";

    useEffect(() => {
        if (!projectId) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        setLoadError(null);
        API.request()
            .endpoint(Endpoints.geograffee)
            .url("/api/DataTransfer/ExportProject")
            .post()
            .addQuery("projectId", projectId)
            .send()
            .then((r: Response) => (r?.ok ? r.text() : Promise.reject()))
            .then((code: string) => {
                const trimmed = code?.trim() ?? "";
                const withoutQuotes = trimmed.replace(/^"|"$/g, "");
                setLink(withoutQuotes || null);
            })
            .catch(() => {
                const msg = t("transfer_project_modal.error_load");
                setLoadError(msg);
                toasts.error(msg);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [projectId, t]);

    const onCopy = useCallback(() => {
        if (!fullLink) return;
        navigator.clipboard.writeText(fullLink).then(
            () => {
                toasts.info(t("link_copied"));
            },
            () => {
                toasts.error(t("transfer_project_modal.error_copy"));
            }
        );
    }, [fullLink, toasts, t]);

    const onClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    const isReady = !!link;

    return (
        <TransferModalBodyLink>
            <TransferModalHeaderRow>
                <TransferModalTitleMain>
                    {isReady ? t("transfer_project_modal.step2_title_ready") : t("transfer_project_modal.step2_title_loading")}
                </TransferModalTitleMain>
                <CloseModalIconWrapper>
                    <CloseModalIcon onClick={onClose} width={22} height={22} />
                </CloseModalIconWrapper>
            </TransferModalHeaderRow>
            <InstructionsList>
                <TransferModalDescription as="li">
                    {t("transfer_project_modal.copy_code")}
                </TransferModalDescription>
                <TransferModalDescription as="li">
                    <Trans i18nKey="transfer_project_modal.receive_project" />
                </TransferModalDescription>
            </InstructionsList>
            <Divider />
            <BottomGroup>
                <TransferModalDescription>
                    {isReady
                        ? t("transfer_project_modal.step2_description_ready")
                        : t("transfer_project_modal.step2_description_loading")}
                </TransferModalDescription>
                <TransferLinkInputWrapperAtBottom>
                    <TransferLinkInput
                        type="text"
                        readOnly
                        value={fullLink}
                        placeholder={t("transfer_project_modal.placeholder")}
                    />
                    <BrgButton variant={ButtonVariant.Filled} disabled={!isReady} onClick={onCopy}>
                        {t("transfer_project_modal.copy")}
                    </BrgButton>
                </TransferLinkInputWrapperAtBottom>
            </BottomGroup>
        </TransferModalBodyLink>
    );
};
